<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/setup/usage-rating/rateplan" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.CreateUsageRatePlan") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <vx-card title card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label mt-1 font-semibold"
                  >{{ $t("setup.label.PlanName") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.PlanName')"
                >
                  <v-select
                    label="planDesc"
                    :options="planData"
                    v-model="Reports.planDesc"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    @input="planName"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mt-1 mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label mt-1 font-semibold"
                  >{{ $t("setup.label.ProductName") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.ProductName')"
                >
                  <v-select
                    label="productDesc"
                    :options="productOptions"
                    v-model="Reports.product"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :reduce="(obj) => obj.productId"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mt-1 mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label mt-1 font-semibold"
                  >{{ $t("setup.label.ChargeCode") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.ChargeCode')"
                >
                  <v-select
                    label="productDesc"
                    :options="chargeCodes"
                    v-model="Reports.charge"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mt-1 mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label mt-1 font-semibold"
                  >{{ $t("setup.label.RUM") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.RUM')"
                >
                  <v-select
                    label="rumName"
                    :options="ReportsData.RumDatas"
                    v-model="Reports.rumName"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mt-1 mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label mt-1 font-semibold"
                  >{{ $t("setup.label.RatingType") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.RatingType')"
                >
                  <v-select
                    label="eventRecordType"
                    :options="output"
                    v-model="Reports.eventRecordType"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mt-1 mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label mt-1 font-semibold"
                  >{{ $t("setup.label.TimeModel") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.TimeModel')"
                >
                  <v-select
                    label="timeModelName"
                    :options="ReportsData.timemdelDatas"
                    v-model="Reports.timeModelName"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :reduce="(obj) => obj.timemodelId"
                    @input="getTimemodelList()"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mt-1 mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label mt-1 font-semibold"
                  >{{ $t("setup.label.ZoneModel") }}
                  <span class="required"> </span
                ></small>
                <!-- <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="zone model"
              > -->
                <v-select
                  label="zoneType"
                  :options="zoneoutput"
                  v-model="Reports.zoneType"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mt-1 mb-2"
                >
                </v-select>
                <!-- <span class="validate-error" style="color: red">{{ errors[0] }}</span>
          </ValidationProvider> -->
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <!-- <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="rate plan name"
            > -->
              <vs-input
                v-model="Reports.ratePlanName"
                :label="$t('setup.label.RatePlanName')"
                class="w-full mb-5 font-semibold"
              />
              <!-- <span class="validate-error" style="color: red">{{ errors[0] }}</span>
          </ValidationProvider> -->
            </div>
            <div style="margin-left: 27.5%">
              <vs-button
                class="mb-2 footerButton-nextusage"
                @click="saveRatePlan"
                >{{ $t("setup.label.Submit") }}</vs-button
              >
              <vs-button
                class="mb-2 footerButton-nextusage ml-10"
                @click="handleAddQuantityTier"
                >{{ $t("setup.label.AddQuantityTier") }}</vs-button
              >
            </div>
          </div>
          <div v-if="timeList.length">
            <div class="vx-row">
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <h4>
                  {{ $t("setup.label.TimePeriod") }}
                </h4>
              </div>
            </div>

            <div class="vx-row mt-6">
              <div class="vx-col w-full">
                <div class="block overflow-x-auto">
                  <table class="w-full">
                    <tr>
                      <td>
                        <b>{{ $t("setup.label.StartYear") }}</b>
                      </td>
                      <td>
                        <b>{{ $t("setup.label.EndYear") }}</b>
                      </td>
                      <td>
                        <b>{{ $t("setup.label.StartMonth") }}</b>
                      </td>
                      <td>
                        <b>{{ $t("setup.label.EndMonth") }}</b>
                      </td>
                      <td>
                        <b>{{ $t("setup.label.StartDay") }}</b>
                      </td>
                      <td>
                        <b>{{ $t("setup.label.EndDay") }}</b>
                      </td>
                      <td>
                        <b>{{ $t("setup.label.StartTime") }}</b>
                      </td>
                      <td>
                        <b>{{ $t("setup.label.EndTime") }}</b>
                      </td>
                      <td>
                        <b>{{ $t("setup.label.Actions") }}</b>
                      </td>
                    </tr>

                    <tr v-for="(timemodels, index) in timeList" :key="index">
                      <td>{{ timemodels.startYear }}</td>
                      <td>{{ timemodels.endYear }}</td>
                      <td>{{ timemodels.startMonth }}</td>
                      <td>{{ timemodels.endMonth }}</td>
                      <td>{{ timemodels.startDay }}</td>
                      <td>{{ timemodels.endDay }}</td>
                      <td>{{ timemodels.startTime }}</td>
                      <td>{{ timemodels.endTime }}</td>

                      <vs-td class="whitespace-no-wrap">
                        <vs-button
                          @click="
                            editPopupYear = true;
                            timeId = timemodels.timeId;
                          "
                          icon-pack="feather"
                          icon="icon-plus"
                          :title="$t('setup.label.Add')"
                          color="success"
                          svgClasses="w-5 h-5
              hover:text-primary stroke-current cursor"
                        >
                        </vs-button>
                      </vs-td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </ValidationObserver>
    <!-- <div class="vx-row center">
      <div class="vx-col w-full">
        <vs-button
          color="primary"
          type="border"
          class="mb-2 footerButton-cancel"
          @click="resetForm"
          >{{ $t("Reset") }}</vs-button
        >
        <vs-button
          class="mr-3 mb-2 footerButton-next"
          @click="createFeemaster"
          >{{ $t("label.button.submit") }}</vs-button
        >
      </div>
    </div> -->
    <div class="centerx">
      <vs-popup
        class="popup-close"
        :title="$t('setup.label.QuantityTier')"
        classContent="popup-example"
        :active.sync="editJobsPopup"
      >
        <ValidationObserver ref="observer1">
          <form>
            <div class="p-3">
              <!-- <div class="vx-row ml-1">Personal Details</div> -->
              <div class="vx-row">
                <div
                  class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('setup.label.TierName')"
                    :key="resetKey"
                  >
                    <vs-input
                      :label="$t('setup.label.TierName')"
                      v-model="Reports.tierName"
                      class="w-full mb-2 font-semibold"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
                <div
                  class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                >
                  <div class="dropdown-with-label">
                    <small class="date-label mt-1 font-semibold"
                      >{{ $t("setup.label.CumulativeResource") }}
                      <span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('setup.label.CumulativeResource')"
                      :key="resetKey"
                    >
                      <v-select
                        label="name"
                        :options="ReportsData.currencyDatas"
                        v-model="Reports.resourceId"
                        :reduce="(obj) => obj.id"
                        :placeholder="$t('placeholder.label.SelectOne')"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full mt-1 mb-2"
                      >
                      </v-select>
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
              <div class="vx-row mt-4">
                <div
                  class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                >
                  <h4>
                    {{ $t("setup.label.TierRange") }}
                  </h4>
                </div>
              </div>
              <div class="vx-row mt-4">
                <div class="vx-col w-1/4">
                  <vs-input
                    :label="$t('setup.label.StepName')"
                    v-model="Reports.stepName"
                    class="w-full mb-2 font-semibold starlabel"
                  />
                </div>
                <div class="vx-col w-1/4">
                  <vs-input
                    :label="$t('setup.label.StartRange')"
                    v-model="Reports.startRange"
                    class="w-full mb-2 font-semibold starlabel"
                  />
                </div>
                <div class="vx-col w-1/4">
                  <vs-input
                    :label="$t('setup.label.EndRange')"
                    v-model="Reports.endRange"
                    class="w-full mb-2 font-semibold starlabel"
                  />
                </div>
                <div class="vx-col md:w-1/4 mt-4" style="margin: 0.5rem 0">
                  <vs-button
                    @click="addParameter"
                    icon-pack="feather"
                    icon="icon-plus"
                    :disabled="
                      !Reports.stepName ||
                      !Reports.startRange ||
                      !Reports.endRange
                    "
                    title="add"
                    color="success"
                    svgClasses="w-5 h-5
              hover:text-primary stroke-current cursor"
                  >
                  </vs-button>
                </div>
              </div>
              <div class="vx-row mt-6">
                <vs-table :data="Reports.regionDatas" class="w-full">
                  <template slot="thead">
                    <vs-th colspan="12">
                      <div class="vx-row w-full">
                        <div class="vx-col w-full md:w-11/12">
                          <div class="vx-row w-full">
                            <div class="vx-col w-full md:w-1/3">
                              {{ $t("setup.label.StepName") }}
                            </div>
                            <div class="vx-col w-full md:w-1/3">
                              <!-- <div class="ml-6"> -->
                              {{ $t("setup.label.StartRange") }}
                              <!-- </div> -->
                            </div>
                            <div class="vx-col w-full md:w-1/3">
                              <!-- <div class="ml-6"> -->
                              {{ $t("setup.label.EndRange") }}
                              <!-- </div> -->
                            </div>
                          </div>
                        </div>
                        <div class="vx-col w-full md:w-1/12">
                          {{ $t("setup.label.Action") }}
                        </div>
                      </div>
                    </vs-th>
                  </template>
                  <template>
                    <vs-tr>
                      <vs-td colspan="12">
                        <div
                          class="vx-row w-full pb-2 pt-2"
                          v-for="(n, i) in Reports.regionDatas.length"
                          :key="n"
                        >
                          <div class="vx-col w-full md:w-11/12">
                            <div class="vx-row">
                              <div class="vx-col w-full md:w-1/3">
                                <vs-input
                                  v-model="Reports.regionDatas[i].stepName"
                                  :placeholder="$t('setup.label.StepName')"
                                  style="width: 100%"
                                  class="mb-2 font-semibold"
                                />
                              </div>
                              <div class="vx-col w-full md:w-1/3">
                                <vs-input
                                  :placeholder="$t('setup.label.StartRange')"
                                  v-model="Reports.regionDatas[i].startRange"
                                  style="width: 100%"
                                  class="mb-2 font-semibold"
                                />
                              </div>
                              <div class="vx-col w-full md:w-1/3">
                                <vs-input
                                  :placeholder="$t('setup.label.EndRange')"
                                  v-model="Reports.regionDatas[i].endRange"
                                  style="width: 100%"
                                  class="mb-2 font-semibold"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/12">
                            <!-- <vs-button
                              v-if="n !== Reports.regionDatas.length"
                              color="success"
                              icon-pack="feather"
                              icon="icon-plus"
                              class="mt-5"
                              type="border"
                              title="add"
                              size="small"
                              style="border-radius: 50%"
                              @click="addItem(i)"
                            ></vs-button> -->
                            <vs-button
                              v-if="n == Reports.regionDatas.length"
                              color="warning"
                              icon-pack="feather"
                              icon="icon-x"
                              class="mt-5"
                              type="border"
                              size="small"
                              style="border-radius: 50%"
                              @click="removeItem(i)"
                            ></vs-button>
                          </div>
                        </div>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
                <!-- <div
                  class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                >
                  <div v-if="Reports.regionDatas.length">
                    <vs-table
                      style="width: 641px; margin-left: 1px"
                      class="mr-1 vx-row w-100"
                      :description-items="paginationItems"
                      description-title="Registries"
                      description-connector="of"
                      description-body="Pages"
                      :data="Reports"
                    >
                      <template slot="thead">
                       
                        <vs-th>{{ $t("setup.label.StepName") }}</vs-th>
                        <vs-th>{{ $t("setup.label.StartRange") }}</vs-th>
                        <vs-th>{{ $t("setup.label.EndRange") }}</vs-th>
                        <vs-th>{{ $t("setup.label.Action") }}</vs-th>
                      </template>
                      <template slot-scope="{ data }">
                        <vs-tr
                          :key="index"
                          :data="Reports"
                          v-for="(Reports, index) in Reports.regionDatas"
                        >
                          <vs-td :data="Reports.stepName">{{
                            Reports.stepName
                          }}</vs-td>
                          <vs-td :data="Reports.startRange">{{
                            Reports.startRange
                          }}</vs-td>
                          <vs-td :data="Reports.endRange">
                            {{ Reports.endRange }}
                          </vs-td>
                          <vs-td class="whitespace-no-wrap">
                            <button
                              @click="removeItem(index)"
                              class="ml-2 mt-4 border-none view_editTable_btn"
                            >
                              <img src="@/assets/images/icons/Trash.svg" />
                            </button>
                          </vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
                </div> -->
              </div>
            </div>
            <div class="vx-row center mb-5">
              <div class="vx-col w-full">
                <vs-button
                  color="primary"
                  type="border"
                  class="mb-2 footerButton-cancel"
                  @click="editJobsPopup = false"
                  >{{ $t("setup.label.Cancel") }}</vs-button
                >
                <vs-button
                  class="mr-3 mb-2 footerButton-next"
                  :disabled="Reports.regionDatas.length == 0"
                  @click.stop="saveQuantityTier"
                  >{{ $t("setup.label.Submit") }}</vs-button
                >
              </div>
            </div>
          </form>
        </ValidationObserver>
      </vs-popup>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example "
        class="popup-close mid-popup"
        :title="$t('setup.label.Usage_Rate_Balance')"
        :active.sync="editPopupYear"
      >
        <!-- <vs-th colspan="12">
          <div class="vx-row">
            <div class="vx-col w-full sm:w-1/2 md:w-1/12 lg:w-1/12 xl:w-1/12">
              {{ $t("Charge Code") }}
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/12 lg:w-1/12 xl:w-1/12">
              {{ $t("Charge Owner") }}
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/12 lg:w-1/12 xl:w-1/12">
              {{ $t("label.discountCode") }}
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/12 lg:w-1/12 xl:w-1/12">
              {{ $t("Price Region") }}
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/12 lg:w-1/12 xl:w-1/12">
              {{ $t("Impact Category") }}
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/12 lg:w-1/12 xl:w-1/12">
              {{ $t("Resource") }}
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/12 lg:w-1/12 xl:w-1/12">
              {{ $t("label.roundingtype") }}
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/12 lg:w-1/12 xl:w-1/12">
              {{ $t("Duration") }}
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/12 lg:w-1/12 xl:w-1/12">
              {{ $t("label.glid") }}
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/12 lg:w-1/12 xl:w-1/12">
              {{ $t("label.heading.value") }}
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/12 lg:w-1/12 xl:w-1/12">
              {{ $t("label.heading.actions") }}
            </div>
          </div>
        </vs-th> -->

        <table class="w-full mb-4">
          <tr>
            <td class="w-13">
              <b>{{ $t("setup.label.UOM") }}</b>
            </td>
            <td class="w-13">
              <b>{{ $t("setup.label.RUM") }}</b>
            </td>
            <td class="w-13">
              <b>{{ $t("setup.label.ImpactCategory") }}</b>
            </td>
            <td class="w-13">
              <b> {{ $t("setup.label.Resource") }}</b>
            </td>
            <td v-if="quantityTireData.tierName" class="w-13">
              <b> {{ quantityTireData.tierName }}</b>
            </td>
            <td class="w-13">
              <b>{{ $t("setup.label.GLID") }}</b>
            </td>
            <td class="w-13">
              <b>{{ $t("setup.label.Unit") }}</b>
            </td>
            <td class="w-13">
              <b>{{ $t("setup.label.Rate") }}</b>
            </td>
            <td class="w-13">
              <b>{{ $t("setup.label.Action") }}</b>
            </td>
          </tr>
          <tr>
            <td class="w-13">
              <v-select
                label="uomName"
                v-model="price.uom"
                :options="ReportsData.UomDatas"
                :placeholder="$t('placeholder.label.SelectOne')"
              >
              </v-select>
            </td>
            <td class="w-13">
              <v-select
                label="rumName"
                v-model="price.rum"
                :options="ReportsData.RumDatas"
                :placeholder="$t('placeholder.label.SelectOne')"
              >
              </v-select>
            </td>
            <td class="w-13">
              <v-select
                label="priceregion"
                v-model="price.impact"
                :options="impactoptions"
                :placeholder="$t('placeholder.label.SelectOne')"
              >
                <template v-slot:option="option">{{
                  option.priceregion
                }}</template>
              </v-select>
            </td>
            <td class="w-13">
              <v-select
                label="code"
                v-model="price.currencyId"
                :options="ReportsData.currencyDatas"
                :placeholder="$t('placeholder.label.SelectOne')"
              >
              </v-select>
            </td>
            <td class="w-13" v-if="quantityTireData.tierName">
              <v-select
                label="stepName"
                v-model="price.stepId"
                :options="quantityTireData.stepsDetailData"
                :placeholder="$t('placeholder.label.SelectOne')"
              >
              </v-select>
            </td>

            <td class="w-13">
              <v-select
                label="id"
                v-model="price.glId"
                :options="ReportsData.glRealatedDatas"
                :placeholder="$t('placeholder.label.SelectOne')"
              >
                <!-- <template v-slot:option="option">{{
                      option.priceregion
                    }}</template> -->
              </v-select>
            </td>
            <td class="w-13">
              <vs-input
                class="w-full mb-2 font-semibold padding-zero"
                v-model="price.unit"
              />
            </td>
            <td class="w-13">
              <vs-input
                class="w-full mb-2 font-semibold padding-zero"
                v-model="price.price"
              />
            </td>
            <td class="w-13 pl-6">
              <feather-icon
                icon="PlusIcon"
                :title="$t('setup.label.Add')"
                svgClasses="w-5 h-5 hover:text-primary stroke-current cursor"
                @click.stop="addData()"
                class="icon_row"
              />
            </td>
          </tr>
          <tr></tr>
        </table>
        <hr />
        <table class="w-full mt-4 normal-table">
          <tr>
            <td>
              <b>{{ $t("setup.label.UOM") }}</b>
            </td>
            <td>
              <b>{{ $t("setup.label.RUM") }}</b>
            </td>
            <td>
              <b>{{ $t("setup.label.ImpactCategory") }}</b>
            </td>
            <td>
              <b> {{ $t("setup.label.Resource") }}</b>
            </td>
            <td v-if="quantityTireData.tierName" class="w-13">
              <b> {{ quantityTireData.tierName }}</b>
            </td>
            <td>
              <b>{{ $t("setup.label.GLID") }}</b>
            </td>
            <td>
              <div style="margin: 9px 0">
                <b>{{ $t("setup.label.Unit") }}</b>
              </div>
            </td>
            <td>
              <b>{{ $t("setup.label.Rate") }}</b>
            </td>
            <td>
              <b>{{ $t("setup.label.Action") }}</b>
            </td>
          </tr>
          <tr v-for="(price, i) in priceList" :key="i">
            <td>
              <div style="margin: 9px 0">{{ price.uom.uomName }}</div>
            </td>
            <td>{{ price.rum.rumName }}</td>
            <td>{{ price.impact }}</td>
            <td>{{ price.currencyId.code }}</td>
            <td v-if="quantityTireData.tierName">
              {{ price.stepId.stepName }}
            </td>
            <td>{{ price.glId.id }}</td>
            <td>{{ price.unit }}</td>
            <td>{{ price.price }}</td>
            <td>
              <feather-icon
                icon="TrashIcon"
                :title="$t('setup.label.Delete')"
                svgClasses="w-5 h-5 text-danger stroke-current cursor"
                @click.stop="removePrice(i)"
                class="icon_row"
              />
            </td>
          </tr>
        </table>

        <div class="vx-row center mb-10">
          <div class="vx-col w-full">
            <vs-button
              color="primary"
              type="border"
              class="mb-2 footerButton-cancel"
              @click="editPopupYear = false"
              >{{ $t("setup.label.Cancel") }}</vs-button
            >
            <vs-button
              class="mr-3 mb-2 footerButton-next"
              @click="editPrices"
              >{{ $t("setup.label.Submit") }}</vs-button
            >
          </div>
        </div>
      </vs-popup>
    </div>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const ReportsEmptyObj = {
  planDesc: "",
  product: "",
  charge: "",
  rumName: "",
  eventRecordType: "",
  timeModelName: "",
  zoneType: "",
  ratePlanName: "",
  regionDatas: [],
  stepName: "",
  startRange: "",
  endRange: "",
  resourceId: "",
  tierName: "",
  usageRateplanId: "",
};
const priceEmptyObj = {
  chargeCode: "",
  chargeOwner: "",
  chargevariant: "",
  currencyId: "",
  discountId: "",
  isPrepaid: "",
  locale: "en",
  planCode: "",
  price: "",
  stepId: "",
  priceregion: "",
  productId: "",
  duration: "",
  roundingType: "",
  glId: "",
  impact: "",
  uom: "",
  rum: "",
  unit: "",
};
export default {
  data() {
    return {
      timeList: [],
      priceList: [],
      Reports: { ...ReportsEmptyObj },
      warningPopup: false,
      warningText: "",
      editPopupYear: false,
      editJobsPopup: false,
      timeId: "",
      impactoptions: [
        "NationalRoamingCall",
        "InternationalZone1RoamingCall",
        "InternationalZone2RoamingCall",
        "LocalCall",
        "NationalCall	",
        "LocalSMS",
        "InternationalSMSIC",
      ],
      errorMessage: "",
      output: ["Continous", "Cumulative"],
      zoneoutput: ["Number", "APN", "Operator", "IC"],
      FieldType: [
        "Numeric",
        "VarChar",
        "TinyInt",
        "Decimal",
        "Text",
        "DateTime",
      ],
      Identifier: ["EventIdentifier", "ServiceIdentifier", "Default"],
      // warningPopup: false,
      // warningText: "",
      price: { ...priceEmptyObj },
      createPriceArray: [],
      editPriceArray: [],
      editPrice: { ...priceEmptyObj },
      priceTemplateData: {},
      chargeOwner: [
        { name: "Self", value: "self" },
        { name: "Parent", value: "parent" },
      ],
      prepaid: false,
      currencyCode: "",
      roundingTypes: [
        "RoundingUp",
        "RoundingDown",
        "RoundingHalf",
        "RoundingNearest",
      ],
      id: "",
      idPrice: "",
      // editToggle: false,
      pricingData: [],
      planData: [],
      productOptions: [],
      chargeCodes: [],
      resetKey: 0,
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      ReportsData: (state) => state.usageRating.GetUsageTemplate,
      timemodel: (state) => state.usageRating.timemodelList,
      priceByPlan: (state) => state.planPrice.priceWithTemplate,
      rateplancreate: (state) => state.usageRating.rateplancreate,
      quantityTireData: (state) => state.usageRating.quantityTireData,
    }),
  },
  methods: {
    removeItem(i) {
      this.Reports.regionDatas.splice(i, 1);
    },
    removePrice(i) {
      this.priceList.splice(i, 1);
    },
    handleAddQuantityTier() {
      this.resetKey++;
      this.editJobsPopup = true;
    },
    addParameter() {
      try {
        let crateParameter = {
          stepName: this.Reports.stepName,
          startRange: this.Reports.startRange,
          endRange: this.Reports.endRange,
        };
        if (this.Reports.regionName !== "") {
          this.Reports.regionDatas = [
            ...this.Reports.regionDatas,
            crateParameter,
          ];
          this.Reports.stepName = "";
          this.Reports.startRange = "";
          this.Reports.endRange = "";
        }
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async addData() {
      if (!this.price.currencyId || !this.price.price || !this.price.unit) {
        this.$swal({
          title: "Opps!",
          icon: "warning",
          text: "Please fill all required fields!",
          type: "warning",
        });
        return;
      }
      this.priceList = [...this.priceList, { ...this.price }];

      this.price = {
        chargeCode: "",
        chargeOwner: "",
        chargevariant: "",
        currencyId: "",
        discountId: "",
        isPrepaid: "",
        locale: "en",
        planCode: "",
        stepId: "",
        price: "",
        priceregion: "",
        productId: "",
        duration: "",
        roundingType: "",
        glId: "",
        impact: "",
        uom: "",
        unit: "",
      };
    },

    async getPriceWithTemplate() {
      try {
        let template = await this.$store.dispatch(
          "planPrice/setPriceWithTemplate",
          this.id
        );

        this.priceTemplateData = this.priceByPlan;
        this.pricingData = this.priceByPlan.pricingData;
        this.editPriceArray = [];
        for (let temp of this.pricingData) {
          for (let itemp of this.priceByPlan.priceRegionData) {
            if (itemp.priceregion == temp.priceregion) {
              temp.priceregion = itemp.id;
              break;
            }
          }
          for (let itemp of this.priceByPlan.chargeData) {
            if (itemp.chargeDescription == temp.chargeCode) {
              temp.chargeCode = itemp.chargeCode;
              break;
            }
          }
          for (let itemp of this.priceByPlan.chargevariant) {
            if (itemp.value == temp.chargeVariant) {
              temp.chargevariant = itemp.id;
              delete temp.chargeVariant;
              break;
            }
          }
          this.editPriceArray.push(temp);
        }
        this.price.isPrepaid = template.data.isPrepaid;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editPrices() {
      const payload = {
        locale: "en",
        ratePlanId: this.Reports.planDesc.planId,
        ratebalance: [],
        usageRateplanId: this.rateplancreate,
      };

      payload.ratebalance = this.priceList.map((el) => {
        return {
          currencyId: el.currencyId.id,
          glId: el.glId.id,
          uomId: el.uom.uomId,
          rumId: el.rum.rumId,
          unit: el.unit,
          rate: el.price,
          timeperiodId: this.timeId,
          stepId: el.stepId.stepId,
          tierId: this.quantityTireData.tierId,
          impactCategory: el.impact,
          ratePlanId: this.rateplancreate,
        };
      });
      try {
        await this.$store.dispatch(
          "usageRating/createUsageRateBalance",
          payload
        );
        this.editPopupYear = false;
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Update Successful!",
          type: "success",
        });
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.routeHold = true;
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async deletePrice(id) {
      await this.$store.dispatch("usageRating/deletePriceAction", id);
      this.getPriceWithTemplate();
    },
    cancel() {
      this.$router.push("/setup");
    },
    resetForm() {
      this.Reports = { ...ReportsEmptyObj };
      this.price = { ...priceEmptyObj };
      this.editPrice = { ...priceEmptyObj };
    },
    planName() {
      this.productOptions = this.Reports.planDesc.products;
      this.chargeCodes = this.Reports.planDesc.chargeCodes;
      // this.Reports.product = this.Reports.planDesc.productDesc;
      // this.Reports.charge = this.Reports.planDesc.chargeCode;
    },
    // removeItem(i) {
    //   this.Reports.columns.splice(i, 1);
    // },
    // addParameter() {
    //   try {
    //     let crateParameter = {
    //       fieldType: this.Reports.fieldType,

    //       identifierType: this.Reports.identifierType,

    //       fieldName: this.Reports.fieldName,
    //       length: this.Reports.length,
    //     };

    //     if (this.Reports.fieldType !== "") {
    //       this.Reports.columns = [...this.Reports.columns, crateParameter];
    //     }
    //     this.resetFormCreatetemplate();
    //   } catch (error) {
    //   throw Error(
    //     error.message.errors[0].defaultUserMessage ||
    //       `Api failed with status code: ${error.message.httpStatusCode}`
    //   );
    // }
    // },
    async saveRatePlan() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      try {
        const payload = {
          planId: this.Reports.planDesc.planId,
          productId: this.Reports.product,
          chargeCode: this.Reports.planDesc.chargeCode,
          rumId: this.Reports.rumName.rumId,
          ratingType: this.Reports.eventRecordType,
          timeModelId: this.Reports.timeModelName,
          planPriceId: this.Reports.planDesc.priceId,
          zoneType: this.Reports.zoneType,
        };
        await this.$store.dispatch("usageRating/createRatePlan", payload);

        this.$swal({
          title: "Success",
          icon: "success",
          text: "Update Successful!",
          type: "success",
        });
        // this.$router.push("/setup/usage-rating/rateplan");
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },

    async getFeemasterTemplate() {
      try {
        await this.$store.dispatch("usageRating/setUsageTemplate");
        const planMap = new Map(
          this.ReportsData.PlanpriceDatas.map((obj) => [obj.planId, obj])
        );
        const arr = Array.from(planMap.values());
        const keys = Array.from(planMap.keys());
        for (const temp of this.ReportsData.PlanpriceDatas) {
          const idx = keys.indexOf(temp.planId);
          const productObj = {
            productDesc: temp.productDesc,
            productId: temp.productId,
          };
          if (!arr[idx].productsMap)
            arr[idx].productsMap = new Map([
              [temp.productId, { ...productObj }],
            ]);
          else arr[idx].productsMap.set(temp.productId, { ...productObj });

          if (!arr[idx].chargeCodeSet)
            arr[idx].chargeCodeSet = new Set([temp.chargeCode]);
          else arr[idx].chargeCodeSet.add(temp.chargeCode);
        }
        for (const temp of arr) {
          temp.products = Array.from(temp.productsMap.values());
          temp.chargeCodes = [...temp.chargeCodeSet];
        }
        this.planData = arr;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    async saveQuantityTier() {
      const isValid = await this.$refs.observer1.validate();
      if (!isValid) return;

      try {
        const payload = {
          usageRateplanId: this.rateplancreate,
          steps: this.Reports.regionDatas,
          range: [
            {
              tierName: this.Reports.tierName,
            },
          ],
          resourceId: this.Reports.resourceId,
          // rumId: this.Reports.rumName.rumId,
          // ratingType: this.Reports.eventRecordType,
          // timeModelId: this.Reports.timeModelName,
          // planPriceId: this.Reports.planDesc.priceId,
        };
        // this.Reports.usageRateplanId = this.rateplancreate;
        // this.Reports.steps = this.Reports.regionDatas;
        // (this.Reports.range = [
        //   {
        //     tierName: this.Reports.tierName,
        //   },
        // ]),
        //   delete this.Reports.tierName;
        // delete this.Reports.charge;
        // delete this.Reports.eventRecordType;
        // delete this.Reports.planDesc;
        // delete this.Reports.product;
        // delete this.Reports.rumName;
        // delete this.Reports.timeModelName;

        // delete this.Reports.regionDatas;
        // delete this.Reports.endRange;
        // delete this.Reports.startRange;
        // delete this.Reports.stepName;
        // delete this.Reports.zoneType;

        await this.$store.dispatch("usageRating/createQuantityTier", payload);
        this.$store.dispatch(
          "usageRating/quantityTireAction",
          this.rateplancreate
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Tier Saved Successful!",
          type: "success",
        });
        if (this.editJobsPopup) this.editJobsPopup = false;
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async getTimemodelList() {
      try {
        await this.$store.dispatch(
          "usageRating/setTimemodelList",
          this.Reports.timeModelName
        );

        const myList = [];
        const myObj = {};
        if (this.timemodel.length == 0) return;
        for (const year of this.timemodel[0].year) {
          myObj.startYear = year.startYear;
          myObj.endYear = year.endYear;
          if (year.month.length == 0) {
            myObj.startMonth = "-";
            myObj.endMonth = "-";
            myObj.startDay = "-";
            myObj.endDay = "-";
            myObj.startTime = "-";
            myObj.endTime = "-";
            myList.push({ ...myObj });
          }
          for (const month of year.month) {
            myObj.startMonth = month.startMonth;
            myObj.endMonth = month.endMonth;
            if (month.day.length == 0) {
              myObj.startDay = "-";
              myObj.endDay = "-";
              myObj.startTime = "-";
              myObj.endTime = "-";
              myList.push({ ...myObj });
            }
            for (const day of month.day) {
              myObj.startDay = day.startDay;
              myObj.endDay = day.endDay;
              if (day.time.length == 0) {
                myObj.startTime = "-";
                myObj.endTime = "-";
                myList.push({ ...myObj });
              }
              for (const time of day.time) {
                myObj.startTime = time.startTime;
                myObj.endTime = time.endTime;

                myObj.timeId = time.timeId;
                myList.push({ ...myObj });
              }
            }
          }
        }

        this.timeList = myList;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    resetFormCreatetemplate() {
      this.Reports = ReportsEmptyObj;
      this.Reports.length = "";
      this.Reports.fieldName = "";
      this.Reports.identifierType = "";
      this.Reports.fieldType = "";
    },
  },
  watch: {
    priceTemplateData(val) {
      this.price.planCode = val.serviceData[0].planCode;
      this.currencyCode = val.currencyCode;
      this.price.currencyId = val.currencyId;
      this.price.chargevariant = val.chargevariant[0].id;
      this.pricingData = val.pricingData;
      for (let temp of val.contractPeriods) {
        if (temp.id == val.duration) {
          this.prepaid = true;
          this.price.duration = temp.Contractdata;
          for (let temp2 of val.chargeData) {
            if (temp2.id == val.duration) {
              this.price.chargeCode = temp2.chargeCode;
            }
          }
          break;
        } else this.price.duration = "";
      }
    },
  },
  created() {},
  mounted() {
    this.resetForm();
    this.id = this.$route.params.id;
    this.getFeemasterTemplate();
    this.getPriceWithTemplate();
  },
};
</script>
<style lang="scss">
// .popup-example {
//   table {
//     td {
//       vertical-align: top;
//       min-width: 100px;
//       padding-bottom: 0.8rem;
//       word-break: break-all;
//     }

//     &:not(.permissions-table) {
//       td {
//         @media screen and (max-width: 370px) {
//           display: block;
//         }
//       }
//     }
//   }
// }
.mid-popup .vs-popup {
  width: 1200px;
  max-width: 100%;
}
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
.popup-example table td {
  vertical-align: middle;
}
.padding-zero {
  padding-top: 0px;
}
::v-deep .vs__selected-options {
  overflow: hidden;
  /* width: 100px; */
  font-size: 14px;
  display: block;
}
.price-table >>> .vs-input--input.normal {
  width: 60px;
  font-size: 14px;
}
.price-table >>> .vs-table-text {
  display: block !important;
}
.less-padding .vx-row > .vx-col {
  padding: 0 4px;
}
.footerButton-nextusage {
  width: 212px;
  height: 38px;
  top: 18px;
}
.w-13 {
  width: 13%;
  padding: 0 4px;
  max-width: 90px;
  &:last-child {
    width: 5%;
  }
}
.vs__selected-options {
  overflow: hidden;
}
.normal-table tr {
  td {
    &:not(:last-child) {
      border-right: 1px solid rgba(var(--vs-primary), 0.3);
    }
    border-bottom: 1px solid rgba(var(--vs-primary), 0.3);
  }

  text-align: center;
}
</style>
